/**
 * Language reference data (T12, frontend-only). Single source for the Settings
 * Profile language picker. Only English ships today (the picker is disabled);
 * defined once here so adding a locale is a one-line change.
 */

/** Selectable UI languages, `[value, label]`. */
const LANGUAGES = [
  ['en', 'English'],
];

export { LANGUAGES };
